import axios from 'axios';

let fetchInstalled = false;
let axiosInstalled = false;

const getAuthTokenForUrl = (url) => {
  if (!url) return null;

  if (url.includes('/api/tutors')) {
    return localStorage.getItem('tutorToken');
  }

  if (url.includes('/api/admin')) {
    return localStorage.getItem('adminToken');
  }

  return null;
};

export const syncAxiosAuthHeader = () => {
  if (axiosInstalled || typeof window === 'undefined') {
    return;
  }

  axios.interceptors.request.use((config) => {
    const url = config.url || '';
    const token = getAuthTokenForUrl(url);

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  axiosInstalled = true;
};

export const installGlobalAuthFetch = () => {
  if (fetchInstalled || typeof window === 'undefined' || !window.fetch) {
    return;
  }

  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    const token = getAuthTokenForUrl(url);

    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return nativeFetch(input, {
      ...init,
      headers,
    });
  };

  fetchInstalled = true;
};
